import React from "react";
import { Link, Navigate } from "react-router-dom";
import { IconArrowLeft } from "@tabler/icons-react";
import Logo from "../images/mercadoagentes_logo.png";
import { useWhitelabel } from "../contexts/WhitelabelContext";
import NewTermsOfUse from "../jsx/components/ModalData/NewTermsOfUse";
import "./LegalDoc.css";

const TermsOfUse = () => {
  const { isWhitelabel } = useWhitelabel();

  if (isWhitelabel) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <div className="d-flex flex-column">
          <Link to="/login" className="legal-back-link">
            <IconArrowLeft size={16} />
            Voltar para o login
          </Link>
          <img src={Logo} alt="MercadoAgentes" className="legal-logo" />
          </div>
          <h1 className="legal-title">Termos de Uso</h1>
          <p className="legal-updated">Última atualização: 21/05/2026</p>
        </div>

        <div className="legal-content">
          <NewTermsOfUse />
        </div>

        <div className="legal-footer">
          <strong>UPSOFT TECNOLOGIA LTDA.</strong>
          CNPJ: 61.304.434/0001-70 | contato@mercadoagentes.com
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
